import { ReactElement } from 'react';
import { Page } from '@client/app/components/App/Page';
import { PrimaryLayout } from '@lib/components/PrimaryLayout';
import { Column } from '@lib/components/PrimaryLayout/Column';
import '@client/product/components/ProductPage/Content/Content.scss';

export const Skeleton = (): ReactElement => (
  <PrimaryLayout>
    <Page className='Product cds-Skeleton-Wrapper--Pulse' title=''>
      <div className='cds-Skeleton--TextMedium' />

      <Column
        left={(
          <div className='ProductGallery-Wrapper'>
            <div className='cds-Skeleton--Thumb' />
          </div>
        )}
        right={(
          <div className='ProductData-Wrapper'>
            <div className='ProductData'>
              <div className='ProductData-Title cds-Skeleton--TextLong cds-Skeleton--TextH1' />

              <div className='Skeleton-PriceList'>
                <div className='Skeleton-ProductPrice'>
                  <div className='cds-Skeleton--TextShort cds-Skeleton--TextH2' />
                  <div className='cds-Skeleton--TextMedium' />
                </div>
              </div>

              <div className='cds-AttributesList--WithPadding'>
                <div className="cds-Skeleton--TextLong" />
                <div className="cds-Skeleton--TextLong" />
                <div className="cds-Skeleton--TextMedium" />
                <div className="cds-Skeleton--TextMedium" />
              </div>

              <table className="ProductData-Features cds-Table cds-Table--Features">
                <tbody>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextMedium" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextMedium" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                  <td>
                    <div className="cds-Skeleton--TextShort" />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div className="ProductData-ActionsWrapper">
              <div className="ProductData-Buy">
                <div className="cds-Skeleton--TextShort cds-Skeleton--TextH1" />
              </div>
            </div>
          </div>
        )}
      />
    </Page>
  </PrimaryLayout>
);
